import { ELanguage, EQuestionAnswerType } from "../../../models"

export interface IQuestion {
    GUId: string
    // it's meaning question order too. 0, 1, 2, 3...
    // PunchIn and PunchOut have separately. i.e PunchIn = 0, 1, 2... PunchOut = 0, 1, 2...
    // RootQuestion priority. if 2 root questions and 3 child questions, root = 0, 1  child = 3, 4, 5
    GroupId: number
    ExternalId: string
    Type: EQuestionAnswerType
    Language: ELanguage
    Body: string
    // add more for punch question
    PunchIn: boolean
    Title: string
    BtnLabel1: string
    BtnLabel2: string

    // we will not use after TieredQuestion
    ExceptionBtnIndex: number
    // if true, prevent punch and notify user
    CreateException: boolean


    NotifyMsg: string
    ModifiedDate: Date | string

    // added for tiered punch question
    Name: string
    Child: boolean
    Frequency: EQuestionFrequency
    //Btn1Action and Btn2Action can have none(-3), CreateException(-2), CreateExceptionPreventPunch(-1), ChildQuestionGroupId(0, 1, 2...)
    Btn1Action: number
    Btn2Action: number
    //CreateBtn1Exception and CreateBtn2Exception is for generating Exception and go to ChildQuestion
    //it's valid when Btn1Action and Btn2Action are ChildQeustionGroupId(0, 1, 2...)
    CreateBtn1Exception: boolean
    CreateBtn2Exception: boolean
    TriggerDuration: ITriggerDuration
}

export enum EQuestionFrequency {
    OncePerDay,
    OnEveryPunch
}

export interface ITriggerDuration {
    Greater: number
    Less: number
}